import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { FaSearch, FaCalendar, FaUser, FaTag } from 'react-icons/fa';
import axios from 'axios';

const API_URL = 'https://aamirsaba.com/api';

const Blog = () => {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedCategory, setSelectedCategory] = useState('All');

  const categories = ['All', 'Training', 'Automation', 'Development', 'Infrastructure', 'News'];

  useEffect(() => {
    axios.get(`${API_URL}/blog`)
      .then(response => {
        console.log('Blog posts loaded:', response.data);
        setPosts(response.data);
        setLoading(false);
      })
      .catch(error => {
        console.error('Error loading blog posts:', error);
        setLoading(false);
      });
  }, []);

  const filteredPosts = posts.filter(post => {
    const matchesCategory = selectedCategory === 'All' || post.category === selectedCategory;
    const matchesSearch = post.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
                          post.excerpt.toLowerCase().includes(searchTerm.toLowerCase());
    return matchesCategory && matchesSearch;
  });

  if (loading) {
    return (
      <section className="pt-32 pb-20 bg-darkNavy min-h-screen">
        <div className="container mx-auto px-6 text-center">
          <div className="text-cyan text-xl">Loading...</div>
        </div>
      </section>
    );
  }

  return (
    <section className="pt-32 pb-20 bg-darkNavy min-h-screen">
      <div className="container mx-auto px-6">
        <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} className="text-center mb-12">
          <h1 className="text-4xl md:text-6xl font-bold">Insights <span className="text-cyan">Blog</span></h1>
          <p className="text-gray-400 mt-4">Latest news and insights from our team</p>
        </motion.div>

        <div className="flex flex-col md:flex-row gap-4 mb-8">
          <div className="flex-1 relative">
            <FaSearch className="absolute left-4 top-1/2 transform -translate-y-1/2 text-gray-500" />
            <input
              type="text"
              placeholder="Search articles..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="w-full pl-12 pr-4 py-3 bg-navy border border-gray-700 rounded-lg text-white focus:border-cyan focus:outline-none"
            />
          </div>
          <div className="flex gap-2 flex-wrap">
            {categories.map((cat) => (
              <button
                key={cat}
                onClick={() => setSelectedCategory(cat)}
                className={"px-4 py-2 rounded-full text-sm font-medium transition " +
                  (selectedCategory === cat
                    ? 'bg-cyan text-navy'
                    : 'bg-navy text-gray-400 border border-gray-700 hover:border-cyan hover:text-white')}
              >
                {cat}
              </button>
            ))}
          </div>
        </div>

        <p className="text-gray-400 text-sm mb-6">Showing {filteredPosts.length} of {posts.length} articles</p>

        {filteredPosts.length === 0 ? (
          <div className="text-center py-12">
            <p className="text-gray-400 text-lg">No articles found matching your criteria.</p>
          </div>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            {filteredPosts.map((post, index) => (
              <motion.div
                key={post.id || index}
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: index * 0.1 }}
                className="bg-navy rounded-xl overflow-hidden border border-gray-800 hover:border-cyan transition group"
              >
                <div className="p-6">
                  <div className="flex items-center gap-2 mb-3">
                    <FaTag className="text-cyan text-xs" />
                    <span className="text-xs text-cyan uppercase tracking-wider">{post.category || 'General'}</span>
                  </div>
                  <h3 className="text-xl font-semibold text-white group-hover:text-cyan transition">{post.title}</h3>
                  <p className="text-gray-400 text-sm mt-2">{post.excerpt}</p>
                  <div className="flex items-center gap-4 mt-4 text-xs text-gray-500">
                    <span className="flex items-center gap-1"><FaCalendar /> {post.date || 'Recent'}</span>
                    <span className="flex items-center gap-1"><FaUser /> {post.author || 'Admin'}</span>
                  </div>
                  <Link to={`/blog/${post.id}`} className="inline-block mt-4 text-cyan hover:text-cyan/80 font-medium hover:underline transition">
                    Read More →
                  </Link>
                </div>
              </motion.div>
            ))}
          </div>
        )}
      </div>
    </section>
  );
};

export default Blog;
